(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDetailController', LabNotificationDetailController);

    LabNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LabNotification', 'Clinic'];

    function LabNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, LabNotification, Clinic) {
        var vm = this;

        vm.labNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:labNotificationUpdate', function(event, result) {
            vm.labNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
